import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTASection = ({ eyebrow = "Continue the journey", title, subtitle, primary, secondary, image }) => {
  return (
    <section className="relative overflow-hidden border-y-2 border-[#D4AF37]/40" data-testid="cta-section">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-15"
        style={{ backgroundImage: `url('${image}')` }}
      />
      <div className="absolute inset-0 bg-[#FBF7F0]/85" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#F2E7D5]/60 via-transparent to-[#F2E7D5]/60" />
      <div className="relative max-w-6xl mx-auto px-4 lg:px-8 py-20 sm:py-28 text-center">
        <div className="overline mb-4 text-[#B65A14]">{eyebrow}</div>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#3B2A1A] max-w-3xl mx-auto leading-tight" style={{ lineHeight: 1.25 }}>
          {title}
        </h2>
        {subtitle && <p className="mt-5 text-[#3B2A1A]/80 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>}
        <div className="mt-9 flex flex-wrap justify-center gap-3">
          {primary && (
            <Link
              to={primary.to}
              className="inline-flex items-center gap-2 rounded-full bg-[#B65A14] text-[#FBF7F0] px-7 py-3.5 text-sm font-semibold hover:bg-[#8F4610] transition shadow-lg"
              data-testid="cta-primary"
            >
              {primary.label} <ArrowRight className="w-4 h-4" />
            </Link>
          )}
          {secondary && (
            <Link
              to={secondary.to}
              className="inline-flex items-center gap-2 rounded-full border border-[#B65A14]/50 text-[#3B2A1A] px-7 py-3.5 text-sm font-semibold hover:bg-[#B65A14]/10 transition"
              data-testid="cta-secondary"
            >
              {secondary.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
